import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import queryString from 'query-string';

import AuthButton from "components/base/AuthButton";
import CustomBreadcrumb from "components/base/CustomBreadcrumb";
import CustomListComponent from "components/base/CustomListComponent";
import ExportRangeModal from "components/base/ExportRangeModal";
import { NavBarNames } from "config/NavBarNameList";
import { PermissionCodes } from "config/PermissionCodes";
import BaseTabListContainer from "containers/base/BaseTabListContainer";
import BaseListContainer from "containers/base/BaseListContainer";
import { ImportResource } from "models/DownloadImportModel";
import MessageCreditRecordFilter from "./MessageCreditRecordFilter";
import { createAction } from "utils";

const MessageCreditRecords = ({
  listFields,
  dataList,
  pageInfo,
  totalCount,
  totalPage,
  checkedList,
}) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [isExportAll, setIsExportAll] =  useState(true);
  const [showExportModal, setShowExportModal] = useState(false);

  const querySearch = queryString.parse(location.search);

  const TabsConfig = [
    { key: "ALL_TYPE", name: 'All Types' },
    { key: "MESSAGE", name: 'Message' },
    { key: "RECURRING_CAMPAIGN", name: 'Recurring Campaign' },
  ];

  useEffect(() => {
    dispatch({ type: 'messageCreditRecord/clearData' });

    const searchKey = querySearch['search'];
    const stringRank = querySearch['rank'] || 'true';
    const stringPage = querySearch['page'] || 1;
    const rank = stringRank === 'true';
    const page = parseInt(stringPage);

    dispatch(
      createAction('messageCreditRecord/getCurrentPageMessageCreditRecords')({
        ...querySearch,
        page,
        reverse: rank,
        search: searchKey,
      }),
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, location]);

  const buttons = [
    <AuthButton
      title="Export Report"
      action={() => {
        setShowExportModal(true)
      }}
      requires={PermissionCodes.addExportjob}
    />,
  ];

  const exportReportAction = () => {
    const searchDict = queryString.parse(location.search);
    const creattionDatePeriod = searchDict?.['create_at']?.split(',');
    const creditConsumedRange = searchDict?.['credit_consumed']?.split(',');
    const nameIcontains = searchDict['search'];
    const whatsappCreditConsumedRange = searchDict?.['whatsapp_credit_consumed']?.split(',');
    const smsCreditConsumedRange = searchDict?.['sms_credit_consumed']?.split(',');
    const emailCreditConsumedRange = searchDict?.['email_credit_consumed']?.split(',');
    const reportIdIn = (checkedList || []).map((item) => item.pk);
    const hasMessage = querySearch['type'] === 'MESSAGE';
    const hasRecurringMessage = querySearch['type'] === 'RECURRING_CAMPAIGN';

    dispatch(
      createAction('downloadAndImport/createDownloadTask')({
        from: ImportResource.messageCreditRecord,
        ...(isExportAll ? null :
          {
            related: {
              nameIcontains,
              reportIdIn,
              creationDateGte: creattionDatePeriod?.[0],
              creationDateLte: creattionDatePeriod?.[1],
              creditConsumedGte: creditConsumedRange?.[0] || null,
              creditConsumedLte: creditConsumedRange?.[1] || null,
              whatsappCreditConsumedGte: whatsappCreditConsumedRange?.[0] || null,
              whatsappCreditConsumedLte: whatsappCreditConsumedRange?.[1] || null,
              smsCreditConsumedGte: smsCreditConsumedRange?.[0] || null,
              smsCreditConsumedLte: smsCreditConsumedRange?.[1] || null,
              emailCreditConsumedGte: emailCreditConsumedRange?.[0] || null,
              emailCreditConsumedLte: emailCreditConsumedRange?.[1] || null,
              hasMessage,
              hasRecurringMessage,
            }
          })
      }),
    );
  }

  const tabs = [
    {
      name: '',
      content: (
        <BaseTabListContainer
          hideTab={false}
          tabs={TabsConfig}
          defaultTabKey={querySearch['type'] || TabsConfig[0].key}
          pageInfo={pageInfo}
          totalCount={totalCount}
          filter={{
            hasFilter: true,
            component: MessageCreditRecordFilter,
          }}
          listContent={
            <BaseListContainer
              fields={listFields}
              dataList={dataList}
              totalPage={totalPage}
              model={'messageCreditRecord'}
              permissionGroup={PermissionCodes.message}
              deleteInfo={{
                data: [],
                title: '',
                relatedName: '',
                onComfirm: {},
              }}
              hasOtherActions={true}
              actions={['Detail']}
              customActions={{
              }}
            />
          }
        />
      )
    },
  ]

  return (
    <>
      <CustomListComponent
        caution={{
          detail: '',
          title: NavBarNames.messageCreditRecords,
        }}
        defaultActiveKey={tabs?.[0]?.name}
        breadcrumb={<CustomBreadcrumb />}
        buttons={buttons}
        tabs={tabs}
        hideTab={true}
      />
      <ExportRangeModal
        show={showExportModal}
        title={`Export Report`}
        closeAction={() => {
          setShowExportModal(false)
        }}
        rightButton={{
          text: 'Export',
          action: () => {
            exportReportAction()
            setShowExportModal(false)
          },
          requires: PermissionCodes.addExportjob,
        }}
        isExportAll={isExportAll}
        setIsExportAll={setIsExportAll}
      />
    </>
  )
}
const mapPropsToState = (state) => ({
  listFields: state.messageCreditRecord.listDisplayFields,
  dataList: state.messageCreditRecord.pagedList,
  pageInfo: state.messageCreditRecord.pageInfo,
  totalPage: state.messageCreditRecord.totalPage,
  totalCount: state.messageCreditRecord.totalCount,
  checkedList: state.messageCreditRecord.checkedList,
});

export default connect(mapPropsToState)(MessageCreditRecords);